/**
 * [GrowthBook] "Complete seu cadastro: não-assinantes" A/B/C experiment.
 * @see feature    https://growthbook.apps.jusbr.com/features/identity_complete_signup_nudge
 * @see experiment https://growthbook.apps.jusbr.com/experiment/exp_d8o4n21mqb4z29v
 */
export const COMPLETE_SIGNUP_NUDGE_FEATURE_KEY = 'identity_complete_signup_nudge'

export const COMPLETE_SIGNUP_NUDGE_VARIANTS = {
  CONTROL: 'control',
  POPOVER: 'a_popover_modal',
  AUTO_MODAL: 'b_auto_modal',
} as const

export type CompleteSignupNudgeVariant =
  (typeof COMPLETE_SIGNUP_NUDGE_VARIANTS)[keyof typeof COMPLETE_SIGNUP_NUDGE_VARIANTS]

// Mirrors the GrowthBook feature default: users outside the experiment coverage
// get 'null' (not bucketed, not tracked) — distinct from 'control' (holdout).
export const COMPLETE_SIGNUP_NUDGE_DEFAULT_VALUE = 'null'

export const COMPLETE_SIGNUP_NUDGE_ORIGIN = 'COMPLETE_SIGNUP_NUDGE'

// Keyed by pid (not device): on a shared device, one user's snooze must not
// suppress the nudge for another user who logs in afterwards.
export const COMPLETE_SIGNUP_NUDGE_SNOOZE_COOKIE_PREFIX = 'complete_signup_nudge_snoozed_'
export const COMPLETE_SIGNUP_NUDGE_SNOOZE_MAX_AGE_SECONDS = 7 * 24 * 60 * 60

export const COMPLETE_SIGNUP_NUDGE_FORCE_COOKIE = 'force_identity_complete_signup_nudge'

export const COMPLETE_SIGNUP_NUDGE_FORCE_MAP: Record<string, CompleteSignupNudgeVariant> = {
  [COMPLETE_SIGNUP_NUDGE_VARIANTS.CONTROL]: COMPLETE_SIGNUP_NUDGE_VARIANTS.CONTROL,
  [COMPLETE_SIGNUP_NUDGE_VARIANTS.POPOVER]: COMPLETE_SIGNUP_NUDGE_VARIANTS.POPOVER,
  [COMPLETE_SIGNUP_NUDGE_VARIANTS.AUTO_MODAL]: COMPLETE_SIGNUP_NUDGE_VARIANTS.AUTO_MODAL,
  a: COMPLETE_SIGNUP_NUDGE_VARIANTS.POPOVER,
  b: COMPLETE_SIGNUP_NUDGE_VARIANTS.AUTO_MODAL,
}

export const COMPLETE_SIGNUP_NUDGE_API_ROUTE = '/api/complete-signup-nudge'

export const COMPLETE_SIGNUP_NUDGE_AUTO_OPEN_DELAY_MS = 2000
